var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"h2-wrapper"},[_c('h2',{staticClass:"hh2",attrs:{"id":_vm.id || null},on:{"click":_vm.toggleContent}},[_vm._t("default"),(_vm.hasContent)?_c('span',{staticClass:"toggle-btn"},[_vm._v(" "+_vm._s(_vm.isHidden ? '+' : '-')+" ")]):_vm._e()],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }